import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const WISHLIST_KEY = 'posterfire_wishlist';

const WishlistContext = createContext(null);

export const useWishlist = () => {
  const context = useContext(WishlistContext);
  if (!context) {
    throw new Error('useWishlist must be used within WishlistProvider');
  }
  return context;
};

const getStoredWishlist = () => {
  try {
    return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
  } catch {
    return [];
  }
};

const saveWishlist = (items) => {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
};

export const WishlistProvider = ({ children }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setItems(getStoredWishlist());
  }, []);

  const addToWishlist = async (productId) => {
    const current = getStoredWishlist();
    if (!current.some(item => item.id === productId)) {
      const updated = [...current, { id: productId }];
      saveWishlist(updated);
      setItems(updated);
    }
  };

  const removeFromWishlist = async (productId) => {
    const current = getStoredWishlist();
    const updated = current.filter(item => item.id !== productId);
    saveWishlist(updated);
    setItems(updated);
  };

  const isInWishlist = (productId) => {
    return items.some(item => item.id === productId);
  };

  const value = {
    items,
    loading,
    addToWishlist,
    removeFromWishlist,
    isInWishlist,
    fetchWishlist: () => setItems(getStoredWishlist()),
    count: items.length
  };

  return (
    <WishlistContext.Provider value={value}>
      {children}
    </WishlistContext.Provider>
  );
};

export default WishlistContext;
